// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2qL-c","name":"ConsentHeader_name__1vAqj","birthday":"ConsentHeader_birthday__j3B3o","skeleton":"ConsentHeader_skeleton__tV0IM"};